import { createSlice } from '@reduxjs/toolkit';
import { sendOtpThunk, verifyOtpThunk } from '../thunk';

const initialState = {
  user: {
    result: {
      phoneNumber: null,
      name: null,
    },
    isLoading: false,
    error: null,
  },

  otpAuth: {
    isLoading: false,
    error: null,
    result: null,
  },
};

export const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearOtpError: (state) => {
      state.otpAuth.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtpThunk.pending, (state) => {
        state.user = {
          isLoading: true,
          result: {
            phoneNumber: null,
            name: null,
          },
          error: null,
        };
      })
      .addCase(sendOtpThunk.fulfilled, (state, { payload }) => {
        state.user = {
          ...state.user,
          isLoading: false,
          result: {
            ...state.user.result,
            phoneNumber: payload.phoneNumber,
          },
        };
      })
      .addCase(sendOtpThunk.rejected, (state, { payload }) => {
        state.user = {
          ...state.user,
          isLoading: false,
          error: payload,
        };
      });

    builder
      .addCase(verifyOtpThunk.pending, (state) => {
        state.otpAuth = {
          isLoading: true,
          result: null,
          error: null,
        };
      })
      .addCase(verifyOtpThunk.fulfilled, (state, { payload }) => {
        state.otpAuth = {
          isLoading: false,
          result: payload,
          error: null,
        };
      })
      .addCase(verifyOtpThunk.rejected, (state, { payload }) => {
        state.otpAuth = {
          isLoading: false,
          result: null,
          error: payload,
        };
      });
  },
});

export const { clearOtpError } = loginSlice.actions;
